import { ChecklistStatus } from '../../common/DocPage.types';

export const ShimmerStatus = {
  keyboardAccessibilitySupport: ChecklistStatus.notApplicable,
  markupSupport: ChecklistStatus.unknown,
  highContrastSupport: ChecklistStatus.pass,
  rtlSupport: ChecklistStatus.pass,
  testCoverage: ChecklistStatus.unknown
};
